import { Link } from "react-router-dom";
import { ArrowUpRight, Plus } from "lucide-react";
import { useQuote } from "@/context/QuoteContext";
import { Reveal } from "@/components/Reveal";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useQuote();
  return (
    <Reveal delay={(index % 4) * 0.07} className="h-full">
      <div className="group flex h-full flex-col" data-testid={`product-card-${product.slug}`}>
        <Link to={`/product/${product.slug}`} data-testid={`view-product-${product.slug}`} className="block">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm bg-stone">
            <img
              src={product.image}
              alt={`${product.name} — ${product.species}`}
              loading="lazy"
              className={`h-full w-full transition-transform duration-700 ease-out group-hover:scale-[1.06] ${
                product.image.startsWith("/") ? "object-contain p-8" : "object-cover"
              }`}
            />
            {product.badge && (
              <span className="absolute left-3 top-3 rounded-full bg-cream/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink">
                {product.badge}
              </span>
            )}
            <div className="absolute inset-x-3 bottom-3 translate-y-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
              <span className="flex items-center justify-center gap-2 rounded-full bg-ink/90 py-2.5 text-[11px] font-bold uppercase tracking-[0.16em] text-cream backdrop-blur-sm">
                View Product <ArrowUpRight size={14} />
              </span>
            </div>
          </div>
          <div className="pt-4">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-sand">
              {product.division} · {product.category}
            </p>
            <h3 className="mt-1 font-display text-xl leading-tight tracking-tight md:text-2xl">
              {product.name}
            </h3>
            <p className="mt-1 text-sm italic text-sand">{product.price_note}</p>
          </div>
        </Link>
        <button
          data-testid={`add-to-quote-${product.slug}`}
          onClick={() => add(product)}
          className="mt-3 flex w-fit items-center gap-2 rounded-full border border-ink/25 px-5 py-2 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors hover:bg-ink hover:text-cream"
        >
          <Plus size={13} /> Add to Quote
        </button>
      </div>
    </Reveal>
  );
}
